import { useMemo } from 'react';

// DEPENDENCIES
import isSameMonth from 'date-fns/isSameMonth';
import startOfDay from 'date-fns/startOfDay';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// VARIABLES
const TODAY = startOfDay(new Date()); // start of day for valid date/time comparisons

// FUNCTIONS
const getDate = status => status ? new Date(status?.sales_time?.toString()?.split('at')?.[0]) : null;

// MAIN COMPONENT
export const useSalesStatus = () => {

  // FORMIK
  const { record: { sale_status_log, sales_status_name } = {} } = useRecordContext();

  // MEMOS
  const [
    backoutStatus,
    carryoverStatus,
    deliveredStatus,
    currentStatus
  ] = useMemo(
    () => [
      sale_status_log?.find(status => status.status_name === 'Backout'),
      sale_status_log?.find(status => status.status_name === 'Carryover'),
      sale_status_log?.find(status => status.status_name === 'Delivered'),
      sale_status_log?.find(status => (status.is_current ? status : null))
    ],
    [sale_status_log]
  )
  const [
    isBackout,
    isCarryover
  ] = useMemo(
    () => [
      sales_status_name === 'Backout',
      sales_status_name === 'Carryover'
    ],
    [sales_status_name]
  )
  const [
    carryoverDate,
    deliveredDate,
    currentStatusDate
  ] = useMemo(
    () => [
      getDate(carryoverStatus),
      getDate(deliveredStatus),
      getDate(currentStatus),
    ],
    [carryoverStatus, deliveredStatus, currentStatus]
  )
  const [
    carryoverinCurrentMonth,
    deliveredinCurrentMonth
  ] = useMemo(
    () => [
      isSameMonth(TODAY, carryoverDate),
      isSameMonth(TODAY, carryoverDate) || isSameMonth(TODAY, deliveredDate),
    ],
    [carryoverDate, deliveredDate]
  );
  const [
    backoutDisabled,
    carryoverDisabled
  ] = useMemo(
    () => [
      carryoverStatus?.is_current && carryoverinCurrentMonth ? false : backoutStatus?.is_current ? true : deliveredStatus?.is_current ? false : true,
      carryoverStatus?.is_current && !carryoverinCurrentMonth ? false : backoutStatus?.is_current ? true : deliveredStatus?.is_current && !deliveredinCurrentMonth ? false : true
    ],
    [backoutStatus, carryoverStatus, deliveredStatus, carryoverinCurrentMonth, deliveredinCurrentMonth]
  )

  return {
    isBackout,
    isCarryover,
    carryoverDate,
    deliveredDate,
    currentStatusDate,
    carryoverinCurrentMonth,
    deliveredinCurrentMonth,
    backoutDisabled,
    carryoverDisabled
  };
}
